import { Button } from "antd";
import { useState } from "react";

import EdgeLogsTable from "./EdgeLogsTable";
import { edgeLogsButtonText } from "./utils";

interface EdgeLogsProps {
  assetId: string;
}

/**
 * A container for showing the edge logs of an asset.
 *
 * Clicking the button starts the GraphQL subscriptions and streams log messages
 * into the table. By clicking the button again, the stream will be stopped and the log messages will
 * be removed.
 */
const EdgeLogs = ({ assetId }: EdgeLogsProps) => {
  const [showEdgeLogs, setShowEdgeLogs] = useState(false);

  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <Button
          type="primary"
          onClick={() => {
            setShowEdgeLogs(!showEdgeLogs);
          }}
          danger={showEdgeLogs}
        >
          {edgeLogsButtonText(showEdgeLogs)}
        </Button>
      </div>
      {showEdgeLogs && <EdgeLogsTable assetId={assetId} />}
    </div>
  );
};

export default EdgeLogs;
